import {
	Checkbox,
	FormControl,
	FormControlLabel,
	TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import Stepper from "../../../../components/Stepper";
import PaymentStepTwo from "./PaymentStepTwo";
import { clone } from "ramda";
import { saveAs } from "file-saver";
import ErrorPopUp from "../../../../components/ErrorPopUp";
import queryString from "query-string";
import Modal from "../../../../components/Modal";
import { useSelector } from "react-redux";
import exit from "../../../../assets/images/exit.svg";

const PaymentByCard = (props) => {
	const {
		handleClose,
		setPanelContent,
		getPaypalInit,
		setPayByCard,
		t,
		paymentInitialData,
		paymentSubmit,
		paymentURL,
		getPaymentData,
		paymentDataAfterPayment,
		paypalInitData,
		callLoginInit,
		paypalLoginInitData,
		paypalComplete,
		paypalSubmit,
		paypalSubmitData,
		getPaymentPaypalData,
		getDataPaymentPaypal,
		loading,
		getPDF,
		pdf,
		getAmounts,
		amounts,
		receiveEmail,
		emailHasBeenSent,
		errorMessageHandler,
		openErrorPopUp,
		setOpenErrorPopUp,
		errorMessageHandlerCardInit,
		errorMessageHandlerAmounts,
		errorSubmitPaypal,
		errorPaypalGetData,
		errorEmailSent,
		initialStep = 0,
		initialAmount = 0,
	} = props;

	const [activeId, setActiveId] = React.useState(null);
	const [amount, setAmount] = React.useState(initialAmount);
	const [checked, setChecked] = React.useState(initialStep > 0);
	const [activeStep, setActiveStep] = React.useState(initialStep);
	const [dataForRedirection, setDataForRedirection] = useState({});
	const [emailText, setEmailText] = useState("");
	const [error, setError] = useState(false);
	const [flagForEmail, setFlagForEmail] = useState(false);
	const [packageAmounts, setPackageAmounts] = useState([]);
	const [clickedSavePdf, setClickedSavePdf] = useState(false);
	const [clickedEmailPdf, setClickedEmailPdf] = useState(false);
	const [clickedPrintPdf, setClickedPrintPdf] = useState(false);
	const [openTerms, setOpenTerms] = useState(false);
	const [isOnPopUpInside, setIsPopUpInside] = useState(false);
	const [isAmountsLoading, setIsAmountsLoading] = useState(false);

	const { isTourist } = useSelector(
		(state) => state.BalanceReducer.payloadAfterLogIn,
	);

	useEffect(() => {
		setIsAmountsLoading(true);
		getAmounts();
	}, [getAmounts]);

	useEffect(() => {
		if (Object.keys(amounts).length === 0) return;
		setPackageAmounts(amounts);
		setIsAmountsLoading(false);
	}, [amounts]);

	useEffect(() => {
		setActiveStep(initialStep);
		setAmount(initialAmount);
		setChecked(initialStep > 0);
	}, [initialStep, initialAmount]);

	useEffect(() => {
		if (!isTourist) return;
		if (paymentDataAfterPayment?.success === true) {
			setActiveStep(2);
		}
	}, [isTourist, paymentDataAfterPayment]);

	useEffect(() => {
		if (activeStep > 0) {
			prepareDataForSubmit(paymentInitialData, amount);
		}
	}, [activeStep, paymentInitialData, amount]);

	useEffect(() => {
		if (errorMessageHandlerCardInit || errorMessageHandlerAmounts) {
			setOpenErrorPopUp(true);
			setIsAmountsLoading(false);
		}
	}, [errorMessageHandlerAmounts, errorMessageHandlerCardInit]);

	useEffect(() => {
		if (Object.keys(getPaymentPaypalData).length !== 0) {
			if (clickedSavePdf) {
				saveAs(handleFile(pdf), "invoice.pdf");
				setClickedSavePdf(false);
			} else if (clickedPrintPdf) {
				openPdf(pdf);
				setClickedPrintPdf(false);
			} else if (clickedEmailPdf) {
				sendEmailReceipt();
				setClickedEmailPdf(false);
			}
		}
	}, [getPaymentPaypalData, pdf]);

	useEffect(() => {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailText)) {
			setError(false);
		} else if (emailText.length === 0) {
			setError(false);
		} else {
			setError(true);
		}
	}, [emailText]);

	useEffect(() => {
		if (emailHasBeenSent || errorEmailSent) {
			setFlagForEmail(true);
		} else {
			setFlagForEmail(false);
		}
	}, [emailHasBeenSent, errorEmailSent]);

	useEffect(() => {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailText)) {
			setError(false);
		} else if (emailText.length === 0) {
			setError(false);
		} else {
			setError(true);
		}
	}, [emailText]);

	function handleFile(pdf) {
		const byteCharacters = window.atob(pdf.pdf);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);
		return new Blob([byteArray], { type: "application/pdf;base64" });
	}

	const openPdf = (pdf) => {
		window.open(URL.createObjectURL(handleFile(pdf)));
	};

	const savePdf = (pdf) => {
		saveAs(handleFile(pdf), "invoice.pdf");
	};

	const printPDF = () => {
		if (Object.keys(pdf).length !== 0) {
			openPdf(pdf);
		} else {
			if (isTourist && paymentDataAfterPayment.success === true) {
				const parsed = queryString.parse(window.location.search);
				getPDF(paymentDataAfterPayment, parsed);
			} else if (getPaymentPaypalData.success === true) {
				getPDF(getPaymentPaypalData, paypalInitData.key);
			}
		}
	};

	const downloadPdf = (e) => {
		if (Object.keys(pdf).length !== 0) {
			savePdf(pdf, Math.random());
		} else {
			if (isTourist && paymentDataAfterPayment.success === true) {
				const parsed = queryString.parse(window.location.search);
				getPDF(paymentDataAfterPayment, parsed);
			} else if (getPaymentPaypalData.success === true) {
				getPDF(getPaymentPaypalData, paypalInitData.key);
			}
		}
	};

	const handleChangeCheckBox = (event) => {
		setChecked(event.target.checked);
		if (amount === 0) {
			setChecked(false);
		}
	};

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};
	const handleBack = () => {
		if (activeStep !== 0) {
			setActiveStep((prevActiveStep) => prevActiveStep - 1);
		} else {
			setPanelContent(true);
			setPayByCard(false);
		}
	};

	const handleEmail = (e) => {
		setEmailText(e.target.value);
	};

	const sendEmailReceipt = (e) => {
		if (emailText.length !== 0 && !error) {
			if (isTourist) {
				receiveEmail(paymentDataAfterPayment, emailText);
				return;
			}
			receiveEmail(getPaymentPaypalData, emailText, paypalInitData.key);
		}
	};

	const prepareDataForSubmit = (paymentInitialData, amount) => {
		let tempInitialClonedData = clone(paymentInitialData);
		let result = { ...tempInitialClonedData, amount };
		setDataForRedirection(result);
	};

	function maskify(card) {
		let hideNum = [];
		for (let i = 0; i < card.length; i++) {
			if (i < card.length - 4 && i > card.length - 11) {
				hideNum.push("X");
			} else {
				hideNum.push(card[i]);
			}
		}
		return hideNum.join("");
	}

	let emailMessage = null;
	if (flagForEmail && emailHasBeenSent) {
		emailMessage = (
			<div
				className="visitLink sendEmailSuccess"
				style={{ marginTop: "10px", textAlign: "right" }}
			>
				<b>{t("emailSuccess")}</b>
			</div>
		);
	} else if (!emailHasBeenSent && flagForEmail) {
		emailMessage = (
			<div
				className="visitLink sendEmailFailed"
				style={{ marginTop: "10px", textAlign: "right", color: "red" }}
			>
				<b>{t("emailFailed")}</b>
			</div>
		);
	} else {
		emailMessage = <div></div>;
	}

	let temp = null;
	if (activeStep === 0) {
		temp = (
			<Fragment>
				<span className="modalTitle">
					<a
						className="goBack hidden nextStep stepBackAlign"
						onClick={handleBack}
					>
						<i className="symmetry-icon-arrow-right"></i>
					</a>
					{isTourist ? t("billPayment") : t("paymentAndRenewal")}
				</span>
				<Stepper t={t} activeStep={activeStep} />
				<div className="paymentContent firstElement">
					<div className="removePayments">
						<div className="paymentContentTitle">{t("chooseAmount")}</div>
						<div className="paymentMethod">
							<div className="paymentDetails noPadding">
								<div className="newTopUp">
									<div className="fixedPackages">
										{isAmountsLoading &&
										!(packageAmounts && packageAmounts.amounts) ? (
											<span
												className="loadingSpinner"
												style={{
													display: "block",
													position: "static",
													border: "4px solid #3d5265",
													borderRightColor: "transparent",
													margin: "20px auto",
												}}
											/>
										) : (
											<ul className="numbersRow avtAmounts">
												{packageAmounts &&
													packageAmounts.amounts &&
													packageAmounts.amounts.map((val, index) => (
														<li
															key={index}
															className={activeId === index ? "active" : ""}
															onClick={() => {
																setActiveId(index);
																setAmount(val.amount);
															}}
														>
															<span className="main">
																{val.amount}
																<i>€</i>
															</span>
														</li>
													))}
											</ul>
										)}
									</div>
								</div>
								<div className="acceptTerms">
									<FormControlLabel
										className="checkbox-accept-terms"
										label={
											<div>
												{t("approval")}
												<a
													style={isTourist ? { color: "#212121" } : undefined}
													onClick={() => {
														setOpenTerms(true);
														setIsPopUpInside(true);
													}}
												>
													{t("termsApproval")}
												</a>
											</div>
										}
										control={
											<Checkbox
												checked={checked}
												onChange={handleChangeCheckBox}
												inputProps={{ "aria-label": "controlled" }}
											/>
										}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="buttonOuter inlineButtons rightAligned">
						<a
							onClick={() => {
								prepareDataForSubmit(paymentInitialData, amount);
								handleNext();
							}}
							className={`button primaryButton primaryButtonNormal${checked === false ? " disabled" : ""}`}
						>
							{t("continue")}
							<span className="loadingSpinner"></span>
						</a>
					</div>
					<img
						src={exit}
						className="close"
						onClick={handleClose}
						alt={t("close")}
					/>
				</div>
				{openErrorPopUp ? (
					<ErrorPopUp
						setOpenErrorPopUp={setOpenErrorPopUp}
						openErrorPopUp={openErrorPopUp}
						t={t}
						text={t("errorGeneral")}
					/>
				) : null}
			</Fragment>
		);
	} else if (activeStep === 1) {
		temp = (
			<PaymentStepTwo
				hideGoBackForTourist={isTourist && initialStep === 1}
				paymentSubmit={paymentSubmit}
				t={t}
				activeStep={activeStep}
				handleBack={handleBack}
				handleNext={handleNext}
				handleClose={handleClose}
				paymentURL={paymentURL}
				dataForRedirection={dataForRedirection}
				getPaymentData={getPaymentData}
				paymentDataAfterPayment={paymentDataAfterPayment}
				paymentInitialData={paymentInitialData}
				paypalInitData={paypalInitData}
				callLoginInit={callLoginInit}
				paypalLoginInitData={paypalLoginInitData}
				paypalComplete={paypalComplete}
				paypalSubmit={paypalSubmit}
				paypalSubmitData={paypalSubmitData}
				getDataPaymentPaypal={getDataPaymentPaypal}
				loading={loading}
				errorMessageHandler={errorMessageHandler}
				setActiveStep={setActiveStep}
				getPaymentPaypalData={getPaymentPaypalData}
				amount={amount}
				getPaypalInit={getPaypalInit}
				errorSubmitPaypal={errorSubmitPaypal}
				errorPaypalGetData={errorPaypalGetData}
			/>
		);
	} else if (activeStep === 2) {
		temp = (
			<Fragment>
				<span className="modalTitle">
					{isTourist ? t("billPayment") : t("paymentAndRenewal")}
				</span>
				<Stepper t={t} activeStep={activeStep} />
				{/*<div className="paymentContent firstElement">*/}
				{/*    <div className="removePayments">*/}
				{/*        <div className="paymentContentTitle textc comsote-green">*/}
				{/*            <h1>{t('congrats')}</h1>*/}
				{/*            <i className="symmetry-icon-trophy cosmote-trophy"></i>*/}
				{/*        </div>*/}
				{/*        <div className="paymentContentTitle textc second-element-spacer">*/}
				{/*            {t('congratsMessage')}*/}
				{/*        </div>*/}
				{/*        <div className="paymentContentTitle second-element-spacer">*/}
				{/*            <p>{t('congratsContent')}</p>*/}
				{/*            <p>{t('congratsContentParagraph')}</p>*/}
				{/*        </div>*/}
				{/*    </div>*/}
				{/*    <div className="buttonOuter inlineButtons textCenter">*/}
				{/*    </div>*/}
				{/*    <div className="close" onClick={handleClose}></div>*/}
				{/*</div>*/}
				<div
					id="paymentPopupContentContainer"
					className="paymentContent thirdStepContent stepsContainer"
					style={{ display: "block" }}
				>
					<div
						id="paymentPopupContentSuccessMessage"
						className="paymentWithIcon"
					>
						{/*<img src="/ote_static/selfcare/img/Icon/Check/Green/32px.svg">*/}
						<span className="paymentWithIconTitle">
							{t("successPaymentMessage")}
						</span>
					</div>
					<div id="content">
						{isTourist &&
							paymentDataAfterPayment.success === true &&
							Object.keys(paymentDataAfterPayment).length !== 0 && (
								<div className="paymentDetails noPadding">
									<div className="paymentDetailsCol">
										<span id="paypalAccountLabel">{t("creditCardNumber")}</span>
										<strong className="paypalAccount">
											{paymentDataAfterPayment?.card?.pan
												? maskify(paymentDataAfterPayment?.card?.pan)
												: paymentDataAfterPayment?.maskedPAN ||
													paymentDataAfterPayment?.maskedPan ||
													""}
										</strong>
									</div>
									<div className="paymentDetailsCol">
										<span id="amountLabel">{t("receiptAmount")}</span>
										<strong className="amount">
											{paymentDataAfterPayment.amount}
										</strong>
										€
									</div>
									<div className="paymentDetailsCol">
										<span id="transactionIdLabel">{t("merchantRefNum")}</span>
										<strong className="paypalOrderId">
											{paymentDataAfterPayment.merchantRef}
										</strong>
									</div>
									<div className="paymentDetailsCol">
										<span id="transactionIdLabel">{t("authCode")}</span>
										<strong className="paypalOrderId">
											{paymentDataAfterPayment.authCode}
										</strong>
									</div>
									<div className="paymentDetailsCol">
										<span id="dueDateLabel">{t("dateTime")}</span>
										<strong className="paymentDate">
											{paymentDataAfterPayment.transactionDate}
										</strong>
									</div>
								</div>
							)}
						{!isTourist && Object.keys(getPaymentPaypalData).length !== 0 && (
							<div className="paymentDetails noPadding">
								{/*<div className="paymentDetailsCol">*/}
								{/*    <span id="customerLabel">Όνομα Πελάτη</span>*/}
								{/*    <strong className="customername">{getPaymentPaypalData.username}</strong>*/}
								{/*</div>*/}
								<div className="paymentDetailsCol">
									<span id="msisdnLabel">{t("mobileNumber")}</span>
									<strong className="renewalMsisdn">
										{getPaymentPaypalData.transferMsisdn}
									</strong>
								</div>
								<div className="paymentDetailsCol">
									<span id="paypalAccountLabel">{t("paypalAccount")}</span>
									<strong className="paypalAccount">
										{getPaymentPaypalData.email}
									</strong>
								</div>
								<div className="paymentDetailsCol">
									<span id="amountLabel">{t("receiptAmount")}</span>
									<strong className="amount">
										{getPaymentPaypalData.amount}
									</strong>
									€
								</div>
								<div className="paymentDetailsCol">
									<span id="transactionIdLabel">{t("transactionCode")}</span>
									<strong className="paypalOrderId">
										{getPaymentPaypalData.paypalTransactionId}
									</strong>
								</div>
								<div className="paymentDetailsCol">
									<span id="dueDateLabel"> {t("dateTime")}</span>
									<strong className="paymentDate">
										{getPaymentPaypalData.datetime}
									</strong>
								</div>
							</div>
						)}
						<div
							id="paymentPopupContentContainer"
							className="paymentContent thirdStepContent stepsContainer"
							style={{ display: isTourist ? "none" : "block" }}
						>
							<div
								id="paymentPopupContentSuccessMessage"
								className="paymentWithIcon"
							>
								<div className="paymentContentTitle textb">
									{t("emailInputTitle")}
								</div>
								<FormControl fullWidth sx={{ m: 1 }} variant="filled">
									<TextField
										error={error}
										helperText={error ? t("emailError") : ""}
										id={
											error
												? "filled-error-helper-text"
												: "filled-adornment-amount"
										}
										type="text"
										label="Email"
										value={emailText}
										onChange={handleEmail}
										variant="filled"
									/>
								</FormControl>
							</div>
							{emailMessage}
						</div>
					</div>

					<div
						className="billActions row"
						style={{ display: isTourist ? "none" : "block" }}
					>
						<a
							id="printPdf"
							className="billAction col-md-3"
							onClick={(e) => {
								setClickedPrintPdf(true);
								printPDF(e);
							}}
						>
							<i className="symmetry-icon-printer"></i>
							{t("print")}
						</a>
						<a
							id="savePdf"
							className="billAction actionPrint col-md-4"
							onClick={(e) => {
								setClickedSavePdf(true);
								downloadPdf(e);
							}}
						>
							<i className="symmetry-icon-document-download"></i>
							{t("savePdf")}
						</a>
						<a
							id="emailPdf"
							className={
								error
									? "billAction actionMail col-md-5 button disabled"
									: "billAction actionMail" + " col-md-5"
							}
							onClick={(e) => {
								setClickedEmailPdf(true);
								if (emailText.length === 0) {
									setError(true);
								} else if (
									/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
										emailText,
									)
								) {
									setError(false);
									sendEmailReceipt(e);
								}
							}}
						>
							<i className="symmetry-icon-email"></i>
							{t("sendEmail")}
						</a>
					</div>
					<div
						className="close"
						onClick={() => {
							window.location.href = "/";
						}}
					></div>
				</div>
			</Fragment>
		);
	}

	return (
		<Fragment>
			{temp}
			{openTerms ? (
				<Modal
					isOnPopUpInside={isOnPopUpInside}
					openTerms={openTerms}
					setOpenTerms={setOpenTerms}
				/>
			) : null}
		</Fragment>
	);
};

export default PaymentByCard;
